import { render, staticRenderFns } from "./Agms.vue?vue&type=template&id=4e04c674&"
import script from "./Agms.vue?vue&type=script&lang=js&"
export * from "./Agms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports